export default __webpack_public_path__ + "static/media/tech-shop.e077ae08.jpg";